import { AuxiliumComponent } from "../auxilium-component";

export class Carousel extends AuxiliumComponent {
	constructor() {
		super();

		this.autoScrollInterval = parseInt(this.getAttribute("auto-scroll-interval")) || 0;
	}

	parsedCallback() {
		const slides = [...this.querySelectorAll(":scope > chip-carouselslide")];

		if (slides.length && !slides.some(x => x.active)) {
			slides.at(0).active = true;
		}

		const activeSlide = slides.find(x => x.active);

		this.appendChild(document.createElementWithContents("div", document.createElementWithContents("ul",
			slides.map(x => document.createElementWithContents("li", x)), {
			className: "carousel__slide-list"
		}), {
			className: "carousel__slide-container"
		}));

		this.append(document.createElementWithContents("chip-button", null, {
			buttonStyle: "icon",
			description: "Previous slide",
			variation: "none",
			onclick: () => this.#GoPrevious(),
			icon: "far fa-chevron-left",
			className: "carousel__action--previous"
		}),
			document.createElementWithContents("chip-button", null, {
				buttonStyle: "icon",
				description: "Next slide",
				variation: "none",
				onclick: () => this.#GoNext(),
				icon: "far fa-chevron-right",
				className: "carousel__action--next"
			}));

		if (activeSlide) {
			this.querySelector(".carousel__slide-list").scrollTo({ left: activeSlide.parentElement.offsetLeft });
		}

		if (this.autoScrollInterval) {
			setInterval(() => {
				this.#GoNext();
			}, this.autoScrollInterval);
		}
	}

	#GoNext() {
		let target = (this.querySelector("chip-carouselslide[active]") ?? this.querySelector("chip-carouselslide"))?.parentElement;

		if (target?.nextElementSibling) {
			target = target?.nextElementSibling.querySelector("chip-carouselslide");
		} else {
			target = this.querySelector("chip-carouselslide");
		}

		if (target) {
			target.active = true;
		}
	}

	#GoPrevious() {
		let target = (this.querySelector("chip-carouselslide[active]") ?? this.querySelector("chip-carouselslide"))?.parentElement;

		if (target?.previousElementSibling) {
			target = target?.previousElementSibling.querySelector("chip-carouselslide");
		} else {
			target = this.querySelector(":scope > div > ul > li:last-child chip-carouselslide");
		}

		if (target) {
			target.active = true;
		}
	}
}